module.exports = __webpack_public_path__ + "a044d491f5234977d6ea4812a6a737bf.jpg";